import React from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  TextField,
  DateField,
  BooleanField,
  NumberField,
  ArrayField,

  FunctionField,
  ReferenceManyField,
  Datagrid,
} from 'react-admin';

const PriceField = ({ record }: any) => (
  <span>${record.price?.toFixed(2)}</span>
);

const EmojiField = ({ record }: any) => (
  <span style={{ fontSize: '2em' }}>{record.emoji}</span>
);

const ColorField = ({ record }: any) => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: '10px' 
  }}>
    <div 
      style={{ 
        width: '30px', 
        height: '30px', 
        backgroundColor: record.color,
        borderRadius: '4px',
        border: '1px solid #ccc'
      }} 
    />
    <span>{record.color}</span>
  </div>
);

export const SupplementShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Основная информация">
        <TextField source="id" label="ID" />
        <EmojiField label="Эмодзи" />
        <TextField source="name" label="Название" />
        <TextField source="subtitle" label="Подзаголовок" />
        <TextField source="description" label="Описание" />
        <ColorField label="Цвет" />
        <PriceField label="Цена" />
        <TextField source="duration" label="Длительность приема" />
        <BooleanField source="isActive" label="Активна" />
        <DateField source="createdAt" label="Создано" showTime />
        <DateField source="updatedAt" label="Обновлено" showTime />
      </Tab>

      <Tab label="Преимущества">
        <FunctionField 
          label="Преимущества" 
          render={(record: any) => 
            record.benefits?.map((benefit: string, index: number) => (
              <span key={index} style={{ 
                display: 'inline-block', 
                padding: '4px 8px', 
                margin: '2px', 
                backgroundColor: '#e8f5e8', 
                borderRadius: '4px',
                fontSize: '0.875rem'
              }}>
                {benefit}
              </span>
            )) || 'Не указаны'
          } 
        />
      </Tab>

      <Tab label="Состав">
        <ArrayField source="composition" label="Состав">
          <Datagrid>
            <TextField source="name" label="Компонент" />
            <TextField source="dosage" label="Дозировка" />
            <TextField source="description" label="Описание" />
          </Datagrid>
        </ArrayField>
      </Tab>

      <Tab label="Рекомендации">
        <FunctionField 
          label="Целевые челленджи" 
          render={(record: any) => 
            record.targetChallenges?.map((challenge: string, index: number) => (
              <span key={index} style={{ 
                display: 'inline-block', 
                padding: '4px 8px', 
                margin: '2px', 
                backgroundColor: '#fff3e0', 
                borderRadius: '4px',
                fontSize: '0.875rem'
              }}>
                {challenge}
              </span>
            )) || 'Не указаны'
          } 
        />
        
        <FunctionField 
          label="Рекомендуемое время приема"
          render={(record: any) => {
            if (record.recommendedTiming) {
              return (
                <div>
                  <div><strong>Время дня:</strong> {record.recommendedTiming.day}</div>
                  {record.recommendedTiming.symptoms?.length > 0 && (
                    <div>
                      <strong>Симптомы:</strong> {record.recommendedTiming.symptoms.join(', ')}
                    </div>
                  )}
                </div>
              );
            }
            return 'Не указано';
          }}
        />
      </Tab>

      <Tab label="Заказы">
        <ReferenceManyField reference="supplementOrders" target="supplementId" label="Связанные заказы">
          <Datagrid>
            <TextField source="id" label="ID заказа" />
            <TextField source="user.name" label="Клиент" />
            <NumberField source="quantity" label="Количество" />
            <FunctionField 
              label="Сумма"
              render={(record: any) => `$${record.totalPrice?.toFixed(2) || '0.00'}`}
            />
            <TextField source="status" label="Статус" />
            <BooleanField source="isPaid" label="Оплачен" />
            <DateField source="createdAt" label="Дата" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>

      <Tab label="Статистика">
        <FunctionField 
          label="Общее количество заказов"
          render={(record: any) => 'Загрузка статистики...'}
        />
        <FunctionField 
          label="Общая выручка"
          render={(record: any) => 'Загрузка статистики...'}
        />
        <FunctionField 
          label="Средний рейтинг"
          render={(record: any) => 'Загрузка статистики...'}
        />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
